import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryOrderColumn } from '../constants/dictionary-order-columns.constant';
import { Link } from 'react-router-dom';

export const generateOrderColumns = (pharmacy) => {
	return [

		{
			align: 'center',
			title: dictionaryOrderColumn[Enviroment.LANGUAGE].quotation_id,
			dataIndex: 'short_code',
			key: 'short_code',
			render: (short_code, record) => (
				<Link to={`/quotation/detail/${record?.quotation_id}`}>
					{short_code}
				</Link>
			),
		},

		{
			align: 'center',
			title: dictionaryOrderColumn[Enviroment.LANGUAGE].preorder_id,
			dataIndex: 'tracking_id',
			key: 'tracking_id',
		},
			{

			align: 'center',
			title: dictionaryOrderColumn[Enviroment.LANGUAGE].order_id,
			dataIndex: 'trx_id',
			key: 'trx_id',
				render: (trx_id,) => (
				<Link to={`/v2/tracking/detail/${pharmacy}/${trx_id}`}>
					{trx_id}
				</Link>
			),
		},

		{
			title: dictionaryOrderColumn[Enviroment.LANGUAGE].request_number,
			dataIndex: 'request_number',
			key: 'request_number',
		},
		{
			title: dictionaryOrderColumn[Enviroment.LANGUAGE].order_date,
			dataIndex: 'order_date',
			key: 'order_date',
		},
		{
			title: dictionaryOrderColumn[Enviroment.LANGUAGE].estimated_delivery_date,
			dataIndex: 'estimated_delivery_date',
			key: 'estimated_delivery_date',
		},
	];
};
